import React, { useEffect } from 'react';
import { Instagram } from 'lucide-react';

const InstagramSection: React.FC = () => {
  const instagramHandle = 'aiperformance.solutions';
  
  useEffect(() => {
    // Load SnapWidget script for automatic Instagram feed
    const script = document.createElement('script');
    script.src = 'https://snapwidget.com/js/snapwidget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-20 bg-gradient-to-b from-dark to-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-bebas text-5xl md:text-7xl text-white mb-4 tracking-wider">
            FOLLOW THE <span className="text-primary">JOURNEY</span>
          </h2>
          <div className="flex items-center justify-center space-x-2 text-gray-400">
            <Instagram className="text-primary" size={24} />
            <a 
              href={`https://instagram.com/${instagramHandle}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="font-montserrat hover:text-primary transition-colors"
            >
              @{instagramHandle}
            </a>
          </div>
          <p className="text-gray-500 text-sm font-montserrat mt-2">
            Latest training moments, client transformations, and fitness tips
          </p>
        </div>

        {/* Automatic Instagram Feed - FREE Solutions */}
        
        {/* Option 1: SnapWidget (Recommended - 100% FREE) */}
        <div className="max-w-7xl mx-auto">
          {/* 
            TO ACTIVATE: 
            1. Go to https://snapwidget.com
            2. Click "Create Your Free Widget"
            3. Select Instagram
            4. Enter username: aiperformance.solutions
            5. Choose Grid layout, 6 photos
            6. Get your widget ID
            7. Replace YOUR_WIDGET_ID below
          */}
          <div className="w-full overflow-hidden rounded-lg bg-black/20 p-2">
            <iframe 
              src="https://snapwidget.com/embed/1108736" 
              className="snapwidget-widget w-full mx-auto" 
              allowTransparency={true} 
              frameBorder={0} 
              scrolling="no" 
              style={{ 
                border: 'none', 
                overflow: 'hidden', 
                width: '100%',
                maxWidth: '800px',
                height: '500px',
                display: 'block'
              }}
              title="Posts from Instagram"
            />
          </div>
          
          <style dangerouslySetInnerHTML={{
            __html: `
              @media (max-width: 768px) {
                .snapwidget-widget {
                  height: 350px !important;
                }
              }
              @media (max-width: 480px) {
                .snapwidget-widget {
                  height: 280px !important;
                }
              }
            `
          }} />
        </div>

        {/* Option 2: Elfsight (FREE tier available) */}
        {/* Uncomment to use Elfsight instead */}
        {/* <div className="elfsight-app-[YOUR-APP-ID]"></div> */}
        {/* <script src="https://static.elfsight.com/platform/platform.js" data-use-service-core defer></script> */}

        {/* Option 3: Curator.io (FREE for 1 source) */}
        {/* Uncomment to use Curator */}
        {/* <div id="curator-feed-default-feed-layout">
          <a href="https://curator.io" target="_blank" className="crt-logo crt-tag">Powered by Curator.io</a>
        </div> */}

        {/* Option 4: Taggbox (FREE trial) */}
        {/* Uncomment to use Taggbox */}
        {/* <div className="taggbox" style={{ width: '100%', height: '600px' }} data-widget-id="YOUR_WIDGET_ID"></div>
        <script src="https://widget.taggbox.com/embed.min.js" type="text/javascript"></script> */}

        <div className="text-center mt-12 px-4">
          <a
            href={`https://instagram.com/${instagramHandle}`}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center bg-gradient-to-r from-purple-600 via-pink-600 to-red-500 hover:from-purple-500 hover:via-pink-500 hover:to-red-400 text-white font-montserrat font-bold px-6 sm:px-12 py-4 sm:py-5 rounded-full shadow-2xl hover:shadow-purple-500/25 transition-all duration-500 transform hover:scale-105 sm:hover:scale-110 hover:-translate-y-1 max-w-full"
          >
            <Instagram className="mr-2 sm:mr-3 group-hover:rotate-12 transition-transform duration-300 flex-shrink-0" size={20} />
            <span className="text-xs sm:text-base md:text-lg tracking-wide break-all sm:break-normal">
              @{instagramHandle.toUpperCase()}
            </span>
            <div className="ml-2 sm:ml-3 w-2 h-2 bg-white rounded-full animate-pulse flex-shrink-0"></div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;